
import ProductsPage from '@/pages/produtos/index.vue'

export default {
  nuxtI18n: {
    paths: {
      br: '/produtos/:category/:subcategory',
      en: '/products/:category/:subcategory',
      es: '/productos/:category/:subcategory'
    }
  },

  ...ProductsPage
}
